export default __webpack_public_path__ + "a9716fcbdc720e75eb81c2dc22840b43.svg";